function formatMoney(value) {
  const number = parseFloat(value);
  return number.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

function renderShippingOptions(rates, resultsBox) {
  if (!Array.isArray(rates) || rates.length === 0) {
    resultsBox.innerHTML = '<p class="no-rates">Sem fretes para este CEP.</p>';
    return;
  }
  const ul = document.createElement('ul');
  ul.className = 'shipping-rates-list';
  rates.forEach(rate => {
    const li = document.createElement('li');
    li.className = 'shipping-rate-item';
    li.innerHTML = `
      <span class="rate-name">${rate.name}</span>
      <span class="rate-price">${formatMoney(rate.price)}</span>
    `;
    ul.appendChild(li);
  });
  resultsBox.innerHTML = '';
  resultsBox.appendChild(ul);
}

window.initCartShippingCalculator = function() {
  const zipInput   = document.getElementById('cart-zip');
  const calcBtn    = document.getElementById('cart-calc-btn');
  const resultsBox = document.getElementById('cart-shipping-results');
  if (!zipInput || !calcBtn || !resultsBox) return;

  // Remove listeners antigos
  zipInput.oninput = null;
  calcBtn.onclick = null;

  zipInput.addEventListener('input', () => {
    const clean = zipInput.value.replace(/\D/g, '');
    calcBtn.disabled = clean.length !== 8;
  });

  calcBtn.addEventListener('click', async () => {
    const cep = zipInput.value.replace(/\D/g, '');
    if (cep.length !== 8) return;

    resultsBox.innerHTML = '<p class="loading">Buscando endereço…</p>';

    // Verifica se há produtos no carrinho
    try {
      const cartRes = await fetch('/cart.js');
      const cartData = await cartRes.json();
      if (!cartData.items || cartData.items.length === 0) {
        resultsBox.innerHTML = '<p class="error">Insira um produto no carrinho para calcular o frete.</p>';
        return;
      }
    } catch (err) {
      resultsBox.innerHTML = `<p class="error">Erro ao verificar o carrinho.</p>`;
      return;
    }

    // 1) Lookup no ViaCEP
    let uf;
    try {
      const viaCepRes  = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
      if (!viaCepRes.ok) throw new Error('Falha ao buscar CEP');
      const viaCepData = await viaCepRes.json();
      if (viaCepData.erro) throw new Error('CEP inválido');
      uf = viaCepData.uf;
    } catch (err) {
      resultsBox.innerHTML = `<p class="error">${err.message}</p>`;
      return;
    }

    // 2) Consulta frete na Shopify
    resultsBox.innerHTML = '<p class="loading">Consultando opções de frete…</p>';
    try {
      const params = new URLSearchParams({
        'shipping_address[zip]':      cep,
        'shipping_address[country]':  'BR',
        'shipping_address[province]': uf
      });

      const shopRes = await fetch(`/cart/shipping_rates.json?${params.toString()}`);
      if (shopRes.status === 422) {
        resultsBox.innerHTML = '<p class="no-rates">Nenhuma opção disponível para este CEP.</p>';
        return;
      }
      if (!shopRes.ok) throw new Error(`HTTP ${shopRes.status}`);
      const { shipping_rates } = await shopRes.json();
      renderShippingOptions(shipping_rates || [], resultsBox);
    } catch (err) {
      resultsBox.innerHTML = `<p class="error">Erro ao consultar frete: ${err.message}</p>`;
    }
  });
};

// Inicializa na primeira carga
document.addEventListener('DOMContentLoaded', window.initCartShippingCalculator);